import styled from 'styled-components';
import { Link, animateScroll as scroll } from "react-scroll";
import { globalStore } from '../../AppManager';
import { useEffect } from 'react';
import GetNavigationList from '../../data/navigation-list';
import HomeIcon from "../../res/icons/home.svg";
import Logo from '../../res/images/logo.png';
import FilledButton from '../buttons/FilledButton';

const Container = styled.nav.attrs({ className: "top-nav" })`
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    background: transparent;
    flex-shrink: 0;
    transition: 0.3s;
    box-sizing: border-box;
    // padding: 1rem;
    border-right: 1px solid var(--black);
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;

    #nav-content {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        // border: 1px solid var(--black);
        border-left: 4px solid var(--yellow);
        // border-bottom: 1px solid var(--black);
        // border-right: 1px solid var(--black);
        // border-radius: 4rem;
        box-sizing: border-box;
        box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.5);

        #nav-top {
            width: 100%;
            background: var(--white);
            padding: 0.5rem 2rem;
            display: none;
            align-items: center;
            justify-content: space-between;

            p {
                color: var(--brand-3);
                font-weight: bold;

                span {
                    color: var(--yellow);
                    font-weight: bold;
                }
            }
        }

        #nav-bottom {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            gap: 0rem;
            align-items: center;
            justify-content: flex-start;
            // background: var(--light-gray);
            // border: 1px solid var(--black);
            // border-radius: 4rem;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(255, 255, 255, .18);
            backdrop-filter: blur(10px);
            // opacity: .92;

            #logo-container {
                width: 300px;
                align-self: stretch;
                border-right: 2px solid var(--muted);
                background-image: url(${Logo});
                background-size: 75%;
                background-position: center;
                background-repeat: no-repeat;
            }
        }

        .nav-item {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 8rem;
            height: 8rem;

            img {
                width: 3rem;
                height: 3rem;
                box-sizing: border-box;
                padding: 0.5rem;
                border-bottom: 1px solid var(--black);
                border-top: 1px solid transparent;
                border-left: 1px solid transparent;
                border-right: 1px solid transparent;
                transition: 0.3s;
                display: none;
            }

            h6 {
                color: var(--black);
            }

            &:hover {
                background: var(--white);
            }

            &:hover h6 {
                color: var(--yellow);
            }

            &:hover img {
                border-color: var(--black);
            }
        }

        .active {
            img {
                background: var(--dark-white);
                border-color: var(--black);
            }
        }
    }

    @media screen and (max-width: 650px) {
        display: none;
    }
`

export default function TopNav() {

    const { visible, setVisible } = globalStore((state) => state.navigation);

    useEffect(() => {
        let section_headers = document.getElementsByClassName("section-header");

        for (var i = 0; i < section_headers.length; i++)
            section_headers[i].id = `section-header${i + 1}`;
    }, [])

    return (
        <Container menuIsVisible={visible}>

            <div id='nav-content'>

                <div id='nav-top'>
                    <p>
                        Looking for bathroom remodeling or floor tiling services? <span>Contact us</span>
                    </p>

                    {/* <FilledButton background="var(--yellow)" text='Request a free estimate'/> */}
                </div>

                <div id='nav-bottom'>

                    <div id='logo-container'>

                    </div>

                    <Link
                        activeClass='active'
                        containerId='app-content'
                        spy={true}
                        smooth={true}
                        duration={1000}
                        className='nav-item'
                        onClick={() => {
                            scroll.scrollTo(0, { containerId: 'app-content', duration: 1000, delay: 300 }); setVisible(false)
                        }
                        }>

                        <img src={HomeIcon} />
                        <h6> Home </h6>

                    </Link>

                    {
                        GetNavigationList().map((item) =>
                            <Link
                                activeClass='active'
                                containerId='app-content'
                                to={item.to}
                                spy={true}
                                smooth={true}
                                duration={1000}
                                delay={300}
                                className='nav-item'
                                onClick={() => setVisible(false)}>

                                <img src={item.icon} />
                                <h6> {item.text} </h6>

                            </Link>
                        )
                    }

                </div>

            </div>

        </Container>
    )
}